module.exports = __webpack_public_path__ + "static/media/bg5.9fb5fcc3.jpg";